import { directus } from "../providers/directus.ts";

export type SecurityState = { must_change_password: boolean; must_setup_tfa: boolean };

/** Setup steps an invited user must finish before using the app. Fails open: an unreachable endpoint must not lock anyone out. */
export async function fetchSecurityState(): Promise<SecurityState> {
  try {
    const res: any = await directus.request(() => ({ method: "GET", path: "/portal/me/security" }));
    const d = res?.data ?? res;
    return { must_change_password: Boolean(d?.must_change_password), must_setup_tfa: Boolean(d?.must_setup_tfa) };
  } catch {
    return { must_change_password: false, must_setup_tfa: false };
  }
}

export function setupRedirect(s: SecurityState): string | null {
  if (s.must_change_password) return "/change-password";
  if (s.must_setup_tfa) return "/tfa-setup";
  return null;
}
